export interface AnalyticsFilterSelectConfig {
  label: string;
  select: string;
  options: unknown[];
  selected?: unknown;
}

export const serviceOptions: AnalyticsFilterSelectConfig = { label: 'Service', select: 'services', options: [] };
export const jobsOptions: AnalyticsFilterSelectConfig = { label: 'Job', select: 'jobs', options: [] };
export const recruitersOptions: AnalyticsFilterSelectConfig = { label: 'Recruiter', select: 'recruiters', options: [] };
export const recruiterLeadsOptions: AnalyticsFilterSelectConfig = {
  label: 'Recruiter Lead',
  select: 'recruiter_leads',
  options: [],
};
export const candidatesOptions: AnalyticsFilterSelectConfig = { label: 'Candidate', select: 'candidates', options: [] };
export const teamLeadsOptions: AnalyticsFilterSelectConfig = { label: 'Team Lead', select: 'team_leads', options: [] };
export const companiesOptions: AnalyticsFilterSelectConfig = { label: 'Company', select: 'companies', options: [] };
export const openingsOptions: AnalyticsFilterSelectConfig = {
  label: 'Opening status',
  select: 'openings_statuses',
  options: [],
};
export const officesOptions: AnalyticsFilterSelectConfig = { label: 'Office location', select: 'offices', options: [] };

export const PLACEHOLDERS: Record<string, string> = {
  [serviceOptions.select]: 'Select service',
  [jobsOptions.select]: 'Select job',
  [recruitersOptions.select]: 'Select Recruiter',
  [recruiterLeadsOptions.select]: 'Select Recruiter Lead',
  [candidatesOptions.select]: 'Select candidate',
  [teamLeadsOptions.select]: 'Select Team Lead',
  [companiesOptions.select]: 'Select company',
  [openingsOptions.select]: 'Select opening status',
  [officesOptions.select]: 'Select office location',
};
